<template>
  <div class="programmesWrapper">
    <div class="columns">
      <div class="column is-half-desktop">
        <div v-for="programme in programmes" class="box">
          <div class="media-content">
            <div class="content">

              <button
              type="button"
              class="delete is-pulled-right"
              @click="remove(programme.id)"></button>

              <p @click="getProgramme(programme.id)">
                <strong>{{ programme.name }}</strong>
                <br>
                {{ programme.created_at }}
              </p>

              <button
                @click="download(programme)"
                target="_blank"
                class="button">
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>
        </div>

        <div
        v-if="programmes.length === 0"
        class="notification"
        @click="$router.push({
          name: 'home'
          })">
          <p>
            <strong>Nog geen programma's beschikbaar</strong>
            <br>
            Stel eerst een programma samen op de homepage
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  computed: {
    programmes () {
      return this.$store.getters.accountData.programmes
    }
  },
  methods: {
    getProgramme (id) {
      this.$store.dispatch('fetchProgramme', id)
    },
    download (programme) {
      this.$store.dispatch('downloadProgramme', programme)
    },
    remove (id) {
      this.$store.dispatch('removeProgramme', id)
    }
  }
}
</script>

<style scoped>
  .delete:hover {
    background-color: hsl(348, 100%, 61%);
  }
</style>



// WEBPACK FOOTER //
// src/components/programmes/Programmes.vue